import React from "react";
import axios from "axios";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";

const token = localStorage.getItem('authToken');

class EditProductCategory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {   
      categoryName: '',
      images: [], // Set to an array to handle multiple images
 
     
      description: '',
      brandarea: '',
      brandName: '',
      submissionStatus: null,
      id: null,
      imagesFile: null,
    };
  }
  
  async componentDidMount() {
    const { match } = this.props;
    if (match && match.params && match.params.id) {
      const { id } = match.params;
      this.setState({ id });
      await this.fetchCategoryData(id);
     
    } else {
      console.error("No match or id found in props");
    }
  }

  fetchCategoryData = async (id) => {
    try {
      const response = await axios.get(`https://brand.aasmo.in/api/admin/getbyid-category/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      const userData = response?.data;
      if (userData) {
        this.setState({
          categoryName: userData?.categoryName || '',
          description: userData?.description || '',
          images: userData?.images || [], // Populate images array
          selectedBrandId: userData?.brands?.[0]?._id || '',
          brandName: userData?.brands?.[0]?.name || '',
          brandarea: userData?.brands?.[0]?.area || '',
        });
      } else {
        console.error("No user data found");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };



  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

 

  handleFileChange = (e) => {
    const { files } = e.target;
    this.setState({ imagesFile: files }); // Store all selected files
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { id } = this.props.match.params;
    const formData = new FormData();
    
    formData.append('categoryName', this.state.categoryName);
    if (this.state.imagesFile) {
      Array.from(this.state.imagesFile).forEach((file) => {
        formData.append('images', file); // Append each image
      });
    }

    formData.append('description', this.state.description);


    try {
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        }
      };
      const response = await axios.put(`https://brand.aasmo.in/api/admin/update-category/${id}`, formData, config);
      if (response && response.status === 200) {
        this.setState({ submissionStatus: 'success' });
        setTimeout(() => {
          this.props.history.push('/list-product-category');
        }, 2000);
      } else {
        console.log('Unexpected response:', response);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  render() {
    const { submissionStatus, images, categoryName, brandOptions, selectedBrandId, description, brandarea, brandName } = this.state;
    return (
      <div className="col-md-12">
        <form onSubmit={this.handleSubmit}>
          <div className="card">
            <div className="header">
              <h2>Edit Product Category</h2>
            </div>
            <div className="card-body">
              <div className="form-group">
                <label>Category Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="categoryName"
                  value={categoryName}
                  onChange={this.handleChange}
                  placeholder="Category Name"
                />
              </div>
              <div className="form-group">
                <label>Images</label>
                <input
                  type="file"
                  className="form-control"
                  name="images"
                  multiple
                  onChange={this.handleFileChange}
                />
                {images && images.map((img, index) => (
                  <img key={index} src={img} alt="category" className="img-thumbnail mt-2" height="100px" width="100px" />
                ))}
              </div>
              <div className="form-group">
                <label>Description</label>
                <input
                  type="text"
                  className="form-control"
                  name="description"
                  value={description}
                  onChange={this.handleChange}
                  placeholder="Brand Description"
                />
              </div>
              {/* <div className="form-group">
                <label>Store</label>
                <select
                  className="form-control"
                  value={selectedBrandId}
                  onChange={this.handleBrandChange}
                >
                  <option value="">Select a Brand</option>
                  {brandOptions.map((brand) => (
                    <option key={brand._id} value={brand._id}>
                      {brand.name}
                    </option>
                  ))}
                </select>
              </div> */}
              {/* {selectedBrandId && (
                <div className="form-group">
                  <label>Store Area</label>
                  <input
                    type="text"
                    className="form-control"
                    name="brandarea"
                    value={brandarea}
                    onChange={this.handleChange}
                    placeholder="Brand Area"
                  />
                </div>
              )} */}
              {submissionStatus === 'success' && (
                <div className="alert alert-success" role="alert">
                  Form submitted successfully!
                </div>
              )}
              <button className="btn btn-primary">Submit</button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default withRouter(EditProductCategory);
